import { DropdownList, SelectedOption } from '@cpm-pr1618001/ng-design-lib';
import { USER_DROPDOWN_LIST } from '../user-constants';

export interface UserLogout {
  isUserLoggedOut: boolean;
}

export interface Notifications {
  uId: number;
  contactUserId: number;
  requestedByUserId?: number;
  isRequester?: boolean;
  email: string;
  firstName?: string;
  lastName?: string;
  date?: string | Date;
  status?: ContactStatusNotification;
  isRead?: boolean;
  trackingId?: number;
}

export enum ContactStatusNotification {
  REQUEST_SENT = 'REQUEST_SENT', // Request has been sent
  REQUEST_RECEIVED = 'REQUEST_RECEIVED', // Request has been received (UI shows ACCEPT - RECEIVER)
  REQUEST_DENIED = 'REQUEST_DENIED', // Request has been denied
  REQUEST_APPROVED = 'REQUEST_APPROVED', // Request has been approved (UI shows SEND REQUEST - SENDER)
  REQUEST_ACCEPTED = 'REQUEST_ACCEPTED', // Request has been accepted
}

export interface ContactNotification {
  contactUserId: number;
  uId: number;
  contactId: number;
  requestedByUserId?: number;
  created_at: Date;
  updated_at?: Date;
  emailId: string;
  firstName: string;
  lastName: string;
  status: ContactStatusNotification;
}

export interface AccountNotification {
  contacts: ContactNotification[];
}

export interface AccountMessage {
  id: number;
  message: string;
  firstName: string;
  lastName: string;
  date: string;
}

export interface Contacts {
  contactUserId: number;
  firstName: string;
  lastName: string;
  emailId: string;
}

export interface UserManagementState {
  userDropdownList: DropdownList[];
  selectedProfileOption: SelectedOption;
  loggedOut: UserLogout;
  isSignOutError: boolean;
  notifications: AccountNotification;
  isNotificationsLoading: boolean;
  messages: AccountMessage[];
  isMessagesLoading: boolean;
  contacts: Contacts[];
  isContactLoading: boolean;
}

export const initialUserManagementState: UserManagementState = {
  userDropdownList: USER_DROPDOWN_LIST,
  selectedProfileOption: null,
  loggedOut: null,
  isSignOutError: false,
  notifications: null,
  messages: null,
  isMessagesLoading: false,
  isNotificationsLoading: false,
  contacts: [],
  isContactLoading: false,
};
